import { Container } from 'react-bootstrap';
/* eslint-disable react/no-array-index-key */
import ArticleDetail from '../../../Components/articleDetail/ArticleDetail';
import ArticleSubSection from '../../../Components/articleSubSection/ArticleSubSection';
import ArticleFooter from '../../../Components/articleFooter/ArticleFooter';
import BulletLinkList from '../../../Components/bulletLinkList/BulletLinkList';
import docImg from '../../../assets/images/png/article2.png';
import './heartBurn.css';
// import BulletLinks from '../../../Components/bulletLinks/BulletLinks';

const subSectionDatas = [
  {
    heading: 'What is heartburn?',
    desc: 'Heartburn is a burning sensation in your chest, behind your breastbone. It occurs when stomach acid travels back up your esophagus — the tube that carries food from your mouth to your stomach. You may also experience a bitter taste in your throat or mouth. The symptoms of heartburn may get worse after you eat or when you’re lying down. In general, you can successfully treat the symptoms of heartburn at home. If frequent heartburn makes it difficult to eat or swallow, however, your symptoms may be a sign of a more serious medical condition.'
  },
  {
    heading: 'What are the symptoms of heartburn?',
    desc: 'Heartburn symptoms can range from mild discomfort to extremely uncomfortable, according to the National Institute of Diabetes and Digestive and Kidney Diseases (NIDDK)Trusted Source. The most common symptom of heartburn is a burning feeling in your chest and throat.'
  },
  {
    heading: 'What does heartburn feel like?',
    desc: 'Heartburn feels like an uncomfortable or burning pain in the middle of your chest. You may also experience:'
  }
];

const heartBurnPoints = [
  'a burning sensation in your throat',
  'pressure or pain behind your breastbone',
  'difficulty swallowing',
  'worsening pain after lying down or bending over',
  'an acidic, sour, or bitter taste in your mouth',
  'coughing or hoarseness'
];

const sourcePoints = [
  { text: 'Acid reflux. (n.d.).', link: 'gi.org/topics/acid-reflux/' },
  { text: 'Antacids. (2019).', link: 'nhs.uk/conditions/antacids/' },
  {
    text: 'Clarrett D, et al. (2018). Gastroesophogeal reflux disease.',
    link: 'ncbi.nlm.nih.gov/pmc/articles/PMC6140167/'
  },
  {
    text: 'Disposal of unused medicines: What you should know. (2020). ',
    link: 'fda.gov/drugs/safe-disposal-medicines/disposal-unused-medicines-what-you-should-know '
  },
  {
    text: 'Eating, diet, & nutrition for GER & GERD. (2020). ',
    link: 'niddk.nih.gov/health-information/digestive-diseases/acid-reflux-ger-gerd-adults/eating-diet-nutrition'
  },
  {
    text: 'Food and Drug Administration. (2020). FDA requests removal of all ranitidine products (Zantac) from the market [Press release]. ',
    link: 'fda.gov/news-events/press-announcements/fda-requests-removal-all-ranitidine-products-zantac-market '
  },
  {
    text: 'Heart attack symptom, risk, and recovery. (2021).',
    link: 'cdc.gov/heartdisease/heart_attack.htm'
  },
  {
    text: 'Heartburn. (2016).',
    link: 'medlineplus.gov/heartburn.html'
  },
  {
    text: 'Heartburn. (2017).',
    link: 'familydoctor.org/condition/heartburn'
  },
  {
    text: 'Martinucci I, et al. (2014). Esophageal motility abnormalities in gastroesophageal reflux disease.',
    link: 'ncbi.nlm.nih.gov/pmc/articles/PMC4023328/'
  },
  {
    text: 'Over-the-counter heartburn treatment. (2021).',
    link: 'fda.gov/drugs/information-consumers-and-patients-drugs/over-counter-otc-heartburn-treatment'
  },
  {
    text: 'Richter JE, et al. (2019). Presentation and epidemiology of gastroesophageal reflux disease.',
    link: 'ncbi.nlm.nih.gov/pmc/articles/PMC5797499/'
  },
  {
    text: 'Symptoms and causes of GERD. (2020).',
    link: 'niddk.nih.gov/health-information/digestive-diseases/acid-reflux-ger-gerd-adults/symptoms-causes'
  },
  {
    text: 'Treatment for GER and GERD. (2020).',
    link: 'niddk.nih.gov/health-information/digestive-diseases/acid-reflux-ger-gerd-adults/treatment'
  },
  {
    text: 'Vasquez J. (2015). Heartburn in pregnancy.',
    link: 'ncbi.nlm.nih.gov/pmc/articles/PMC4562453/'
  }
];

const tags = [
  { text: 'Overview', link: '/' },
  { text: 'Symptoms', link: '/' },
  { text: 'Home Remedies', link: '/' },
  { text: 'Causes', link: '/' },
  { text: 'Treatment', link: '/' },
  { text: 'Diagnosis', link: '/' },
  { text: 'Complications', link: '/' },
  { text: 'Prevention', link: '/' }
];

function HeartBurn() {
  return (
    <section>
      <Container>
        <ArticleDetail
          articleReviewImage={docImg}
          articleReviewByName="Medically reviewed by Chris Young, DNP, RN, NE-BC, NPD — "
          articleWrittenByName="Written by Darla Burke — "
          articleUpdateOn="Updated on November 30, 2021"
          articleTitle="What You Need to Know About Heartburn"
          qouteHeading="WITHDRAWAL OF RANITIDINE"
          tagData={tags?.map(({ text, link }) => ({
            tagText: text,
            tagLink: link
          }))}
          qouteDesc="In April 2020, the Food and Drug Administration (FDA)Trusted Source requested that all forms of prescription and over-the-counter (OTC) ranitidine (Zantac) be removed from the U.S. market. This recommendation was made because unacceptable levels of NDMA, a probable carcinogen (cancer-causing chemical), were found in some ranitidine products. If you’re prescribed ranitidine, talk with your doctor about safe alternative options before stopping the drug. If you’re taking OTC ranitidine, stop taking the drug and talk with your healthcare professional about alternative options. Instead of taking unused ranitidine products to a drug take-back site, dispose of them according to the product’s instructions or by following the FDA’s guidanceTrusted Source."
        />
        {subSectionDatas.map((subSectionData, index) => (
          <ArticleSubSection
            key={index}
            heading={subSectionData.heading}
            desc={subSectionData.desc}
          />
        ))}
        <BulletLinkList
          points={heartBurnPoints.map((burnPoints) => ({
            pointText: burnPoints
          }))}
        />
        <ArticleFooter
          sourceReviewDate="Last medically reviewed on October 20, 2021"
          sourceHeading="15 sources"
          sourceDesc="Healthline has strict sourcing guidelines and relies on peer-reviewed studies, academic research institutions, and medical associations. We avoid using tertiary references. You can learn more about how we ensure our content is accurate and current by reading our editorial policy."
          sourceContent={[
            <BulletLinkList
              points={sourcePoints.map(({ link, text }) => ({
                pointText: text,
                pointLink: link,
                pointlinkText: link
              }))}
            />
          ]}
        />
      </Container>
    </section>
  );
}

export default HeartBurn;
